import axios from "axios";
import utility from "@/util/utility";
import router from "@/router";
import store from "@/store";

const axiosInstance = axios.create({
    baseURL: utility.URL_SAVE+utility.URL_BASE+":8080/api",
    headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "access-control-allow-origin,content-type"
    },
    withCredentials: true,
})

axiosInstance.interceptors.response.use(function (resp) {
    if(resp.headers['new-token']) {
        console.log("Got new token: " + resp.headers['new-token'])
        store.dispatch("auth/updateToken", resp.headers['new-token'])
    }
    return resp;
}, undefined);

axiosInstance.interceptors.response.use(undefined, function (err) {
    return new Promise(function () {
        var response = err.response;
        if (response.status === 401 && response.config && !response.config.__isRetryRequest && response.data.error === 'Token expired') {
            localStorage.removeItem('user');
            localStorage.removeItem('companyData');
            localStorage.removeItem('connectionData')
            localStorage.removeItem('SelectedTeam')
            store.dispatch("company/clearCompanyAction");
            store.dispatch('stomp/setConnectionStateAction',false);
            store.dispatch('auth/logout');
            router.push('/login');
        }
        else if(response.status === 403) {
            router.push('/error_403');
        }
        else if(response.status === 404) {
            router.push('/error_404');
        }
        throw err;
    });
});

export default axiosInstance;